import React, {useEffect, useMemo, useState} from "react";
import axios from "axios";
import "./AddDocumentToCase.css";
import {
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip
} from "@mui/material";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CaseFilesInternal from "../../../enums/CaseFilesInternal";
import {IoIosCloseCircle} from "react-icons/io";
import CaseFilesStatus from "../../../enums/CaseFilesStatus";
import DatePicker from "react-datepicker";
import {FaEdit} from "react-icons/fa";
import {ka} from "date-fns/locale";
import {addMonths, parseISO} from "date-fns";
import JoditEditor from "jodit-react";
import CaseNotificationEnum from "../../../enums/CaseNotiFicationEnum";
import {jwtDecode} from "jwt-decode";
import CaseFileDeclined from "../../../enums/CaseFileDeclined";
import UploadSingleAttachment from "../../../components/CaseInsideTable/UploadSingleAttachment";
import {MdFileUpload} from "react-icons/md";
import {AiOutlineCheckCircle} from "react-icons/ai";
import AllowedFormatsInfo from "./AllowedFormatsInfo";


const EditCaseDocument = ({
                              onFileAdded,
                              getFileId,
                              holidays,
                              users,
                              permitTypeId,
                              caseData,

                          }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [title, setTitle] = useState("");
    const [documentType, setDocumentType] = useState("");
    const [isShared, setIsShared] = useState(false);
    const [isSharedExpert, setIsSharedExpert] = useState(false);
    const [isExtentionAttachment, setIsExtentionAttachment] = useState(false);
    const [orderDecision, setOrderDecision] = useState(null);
    const isBlank = true
    const [declineStatus, setDeclineStatus] = useState(null);
    const [conditionalDeadLine, setConditionalDeadLine] = useState(null);
    const [termOfPermitDate, setTermOfPermitDate] = useState(null);
    const [tempProlongationDays, setTempProlongationDays] = useState(0);
    const [extraDescription, setExtraDescription] = useState("");
    const [answerStatus, setAnswerStatus] = useState(null);
    const [departmentID, setDepartmentId] = useState(null);
    const [isSecretDoc, setIsSecretDoc] = useState(null);
    const [toUserId, setToUserId] = useState(null);
    const [activeUserId, setActiveUserId] = useState(null);
    const [skipVisage, setSkipVisage] = useState(false);
    const [isDocumentInternal, setIsDocumentInternal] = useState(false);
    const [pureDays, setPureDays] = useState(null);
    const [documentNumber, setDocumentNumber] = useState(null);
    const [caseFileNumber, setCaseFileNumber] = useState(null);
    const [additionalInternalDocumentation, setAdditionalInternalDocumentation] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [hideCase, setHideCase] = useState(isSecretDoc === 1);
    const [loading, setLoading] = useState(true);
    const [isEditing, setIsEditing] = useState(false);
    const [editorContent, setEditorContent] = useState('');
    const [oldDocId, setOldDocId] = useState(null);
    const urlParams = new URLSearchParams(window.location.search);
    const urlCaseId = urlParams.get("id");
    const [closing, setClosing] = useState(false);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [postpone, setPostpone] = useState(null);
    const [postponeDate, setPostponeDate] = useState(null);
    const [approvalDocument, setApprovalDocument] = useState(false);
    const [previewContent, setPreviewContent] = useState('');
    const [fontFamily, setFontFamily] = useState('Sylfaen');
    const [childrenFiles, setChildrenFiles] = useState([]);
    const [caseFiles, setCaseFiles] = useState([]);
    const [fileToDelete, setFileToDelete] = useState(null);
    const [isDeleteConfirmModalOpen, setIsDeleteConfirmModalOpen] = useState(false);
    const minDate = new Date();
    const maxDate = addMonths(new Date(), 3);
    const [excludedDates, setExcludedDates] = useState([]);
    const [closeModalOn, setCloseModalOn] = useState(false);
    const [newFileNumber, setNewFileNumber] = useState(false);
    const [roleId, setRoleId] = useState('');
    const [showUploadPopupAttachment, setShowUploadPopupAttachment] = useState(false);
    const [fileIdForAttachment, setFileIdForAttachment] = useState('');
    const [isLoadingCaseFiles, setIsLoadingCaseFiles] = useState(false);

    useEffect(() => {
        if (isSecretDoc === 1){
            setHideCase(true)
        }
    }, [isSecretDoc]);

    const fetchCaseFiles = async () => {
        setIsLoadingCaseFiles(true);
        try {
            const token = localStorage.getItem("jwtToken");
            if (!token) {
                setIsLoadingCaseFiles(false);
                return;
            }

            const id = new URLSearchParams(window.location.search).get("id");
            if (!id) {
                setIsLoadingCaseFiles(false);
                return;
            }

            let endpoint;
            if (roleId === 'USER') {
                endpoint = `${baseURL}/GetAllCaseSharedFileByCaseID?CaseId=${id}`;
            } else if (roleId !== null) {
                endpoint = `${baseURL}/GetAllCaseFileByCaseID?CaseId=${id}`;
            }

            const response = await axios.get(endpoint);

            let data;
            if (roleId === 'USER') {
                data = response.data.data;
            } else {
                data = response.data.data.resultItems;
            }


            if (Array.isArray(data)) {
                const reversedData = data.reverse();
                setCaseFiles(reversedData);

            } else {
            }
        } catch (error) {
        } finally {
            setIsLoadingCaseFiles(false);
        }
    };
    useEffect(() => {
        if (showPopup) {
            void fetchCaseFiles()
        }
    }, [showPopup]);

    const toggleUploadPopupAttachment = (fileId) => {
        setFileIdForAttachment(fileId)
        setShowUploadPopupAttachment(!showUploadPopupAttachment);
    };

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);

    const handleDeclineReasonChange = (e) => {
        setDeclineStatus(e.target.checked ? CaseFileDeclined.CaseCancellationDocument : CaseFileDeclined.CaseCancellationDocumentDeclined);
    };
    const handleDeclineReasonChangeBuilding = (e) => {
        setDeclineStatus(e.target.checked ? CaseFileDeclined.RequireCaseCancellationBuildingAnswer : CaseFileDeclined.RequireCaseCancellationBuildingAnswerDenied);
    };
    const sendNotification = async (fileId) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: urlCaseId ? parseInt(urlCaseId, 10) : 0,
            documentId: fileId,
            action: CaseNotificationEnum.editedFile.id,
            caseStatus: 8,
            viewed: true,

        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const georgianTranslations = {
        "Type something": " ",
        "Bold": "ტექსტის გამუქება",
        "Italic": "დახრილი ტექსტის შექმნა",
        "Underline": "ტექსტის ხაზგასმა",
        "Insert Image": "სურათის ჩასმა",
        "Clear Formatting": "ფორმატირების წაშლა",
        "Insert Format Block": "ფორმატირების ბლოკის ჩასმა",
        "Strike through": "გადახაზული",
        "Insert Unordered List": "ბურთულებიანი სიის შექმნა",
        "Insert Ordered List": "დანომრილი სიის შექმნა",
        "Font family": "შრიფტის არჩევა",
        "Font size": "შრიფტის ზომა",
        "Line height": "ხაზის დაშორება",
        "Insert Horizontal Line": "ხაზის დაშორება",
        "Increase Indent": "დაშორების გაზრდა",
        "Decrease Indent": "დაშორების შემცირება",
        "Undo": "უკუსვლა",
        "Redo": "საწყისი",
        "Align": "სწორება",
        "Insert Special Character": "სპეც. სიმბოლო",
        "Fill color or set the text color": "ფერის შეცვლა",
        "Background": "ფონი",
        "Text": "ტექსტი",
        "Insert format block": "ფორმატირება",
        "Print": "დაბეჭვდა",
        "Show all": "მეტის ნახვა",
        "Insert link": "ბმლის ჩასმა",
        "URL": "ბმული",
        "Open in new tab": "ახალ გვერდზე გახსნა",
        "Insert": "ჩასმა"
    };

    const mapFontFamilyToStyles = (fontName) => {
        const fontStyles = {
            'Arial': {
                fontFamily: 'arial_geo',
                bold: 'arial_geo-bold',
                italics: 'arial_geo-italic',
                bolditalics: 'arial_geo-bold-italic'
            },
            'Sylfaen': {
                fontFamily: 'sylfaen',
                bold: 'arial_geo-bold',
                italics: 'arial_geo-italic',
                bolditalics: 'arial_geo-bold-italic'
            }
        };
        return fontStyles[fontName] || fontStyles['Arial'];
    };


    const editorConfig = useMemo(() => ({
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        style: {
            fontFamily: mapFontFamilyToStyles(fontFamily).fontFamily,
        },
        height: 800,
        disablePlugins: [
            'table',
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
            'symbol',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: [
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', '|',
            'font', 'fontsize', 'brush', 'paragraph', '|',
            'image', 'table', 'link', '|',
            'align', 'undo', 'redo', '|',
            'hr', 'eraser', 'copyformat', '|',
            'symbol', 'fullsize', 'print', 'about'
        ],
    }), []);


    useEffect(() => {
        const styleSheet = document.createElement('style');
        styleSheet.type = 'text/css';
        styleSheet.innerText = `
        .jodit-container * {
            font-family: ${mapFontFamilyToStyles(fontFamily).fontFamily} !important;
        }
    `;
        document.head.appendChild(styleSheet);

        return () => {
            document.head.removeChild(styleSheet);
        };
    }, [fontFamily]);

    useEffect(() => {
        if (documentNumber && caseFileNumber) {
            if (caseFileNumber.length > 4) {
                setNewFileNumber(caseFileNumber)
            } else if (caseFileNumber.charAt(0) === "/") {

                setNewFileNumber(documentNumber + caseFileNumber)
            } else if (caseFileNumber.charAt(0) !== "/") {
                setNewFileNumber(caseFileNumber + documentNumber)
            }

        } else {
            setNewFileNumber(null)
        }

    }, [documentNumber]);

    const preprocessHtmlForPdf = (html) => {
        const container = document.createElement('div');
        container.innerHTML = html;

        const elementsWithStyle = container.querySelectorAll('[style]');
        elementsWithStyle.forEach(element => {
            const style = element.style;

            if (style.fontSize && isNaN(parseFloat(style.fontSize))) {
                style.fontSize = '16px';
            }

            if (style.textDecoration === 'none') {
                style.textDecoration = '';
            }
        });
        const tables = container.querySelectorAll('table');
        tables.forEach(table => {
            table.style.width = '100%'; // Ensures tables stretch to the full page width
            const rows = table.querySelectorAll('tr');
            rows.forEach(tr => {
                tr.querySelectorAll('td, th').forEach(td => {
                    td.style.padding = '8px'; // Ensure consistent padding
                });
            });
        });

        return container.innerHTML;
    };


    async function editAttachmentFiles(file, newParentId) {
        const updatedFileData = {...file, parentId: newParentId};
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, updatedFileData);
    }


    useEffect(() => {
        if (holidays) {
            const parsedHolidays = holidays.map(holiday => parseISO(holiday.date));
            setExcludedDates(parsedHolidays);
        }
    }, [holidays]);



    const deleteDocument = async () => {
        setLoading(true);
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteCaseFile`, {
                caseFileId: getFileId
            });
        } catch (error) {
            console.error("Error deleting document:", error);
        } finally {
            setLoading(false);
        }
    };
    const deleteAttachedDocument = async (fileID) => {
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteCaseFile`, {
                caseFileId: fileID
            });
            setChildrenFiles((prevFiles) => prevFiles.filter(file => file.id !== fileID));
        } catch (error) {
            console.error("Error deleting document:", error);
        }
    };



    const handleFontChange = (e) => {
        setFontFamily(e.target.value);
    };


    const preprocessEditorContent = (htmlContent) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');

        doc.querySelectorAll('p, br').forEach(el => {
            if (el.style.marginTop === '70px') {
                el.style.marginTop = '0px';
            }
        });

        return doc.body.innerHTML;
    };

    useEffect(() => {
        const processedContent = preprocessEditorContent(editorContent);
        setEditorContent(processedContent);
    }, [editorContent]);




    useEffect(() => {
        const fetchData = async () => {
            const jwtToken = localStorage.getItem('jwtToken');
            try {
                if (urlCaseId && jwtToken) {
                    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseFileByCaseID?CaseId=${urlCaseId}`);
                    if (response.data && response.data.success) {
                        handleData(response.data.data.resultItems);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        if (caseFiles.length !== 0) {
            void fetchData();
        }

    }, [urlCaseId, caseFiles]);

    const handleData = (data) => {
        setLoading(true)

        const documentData = data.find(item => item.id === getFileId);
        if (documentData) {
            setTitle(documentData.name);
            setDeclineStatus(documentData.decline);
            setApprovalDocument(documentData.approvalDocument);
            if (documentData.conditionalDeadLine) {
                setConditionalDeadLine(new Date(documentData.conditionalDeadLine));
            }
            if (documentData.termOfPermitDate) {
                setTermOfPermitDate(new Date(documentData.termOfPermitDate));
            }
            setTempProlongationDays(documentData.tempProlongationDays);
            const childrenFilesToAttach = caseFiles.filter(parentFile => parentFile.parentId === documentData.id);
            setEditorContent(documentData.mainInfo);
            setExtraDescription(documentData.additionalInfo || '');
            setOldDocId(documentData.id);
            setIsShared(documentData.sharedTemp);
            setIsSharedExpert(documentData.shared);
            setIsExtentionAttachment(documentData.isExtentionAttachment);
            setOrderDecision(documentData.orderDecision);
            setDocumentType(documentData.documentType.toString());
            setPostpone(documentData.postpone);
            setPostponeDate(documentData.postponeDate ? new Date(documentData.postponeDate) : null);
            setChildrenFiles(childrenFilesToAttach);
            setAnswerStatus(documentData.answerStatus)
            setDepartmentId(documentData.departamentId)
            setIsSecretDoc(documentData.isSecretDoc)
            setToUserId(documentData.toUserId)
            setActiveUserId(documentData.activeUserId)
            setSkipVisage(documentData.skipVisage)
            setIsDocumentInternal(documentData.isDocumentInternal)
            setPureDays(documentData.pureDays)
            setDocumentNumber(documentData.documentNumber)
            setCaseFileNumber(documentData.casefileNumber)
            setAdditionalInternalDocumentation(documentData.additionalInternalDocumentation)
        }
        setTimeout(() => setLoading(false), 1500)
    };

    useEffect(() => {
        console.log(isSecretDoc)
    }, [showPopup]);

    function isEditorContentEmpty(content) {
        return !content.replace(/<[^>]*>/g, '').trim();
    }

    const isSubmitDisabled = !title || isEditorContentEmpty(editorContent) || !documentType;

    const handleClosePopup = () => {
        if (showPopup) {
            setCloseModalOn(false)
            onFileAdded()
            setClosing(true);
            setTimeout(() => {
                setShowPopup(false);
                setClosing(false);
            }, 500);
        }

    };

    useEffect(() => {
        const toolbar = document.querySelector('.ck-toolbar');
        if (toolbar) {
            toolbar.classList.add('fixed-toolbar');
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsConfirmModalOpen(true);
    };


    const handleConfirmSubmit = async () => {
        setIsConfirmModalOpen(false);
        setLoading(true);
        setIsEditing(true)
        await deleteDocument();

        const forceFontFamily = (htmlContent) => {
            const container = document.createElement('div');
            container.innerHTML = htmlContent;
            Array.from(container.querySelectorAll("*")).forEach(el => {
                el.style.fontFamily = fontFamily;
            });
            return container.innerHTML;
        };

        const updatedPreviewContent = forceFontFamily(previewContent.replace(/background-color:\s*transparent;\s*/g, ''));
        const updatedEditorContent = forceFontFamily(editorContent.replace(/background-color:\s*transparent;\s*/g, ''));

        setPreviewContent(updatedPreviewContent);
        setEditorContent(updatedEditorContent);

        const processedContent = preprocessHtmlForPdf(`<div style="font-family: ${fontFamily}">${updatedPreviewContent}${updatedEditorContent}</div>`);


            const requestBody = {
                caseID: parseInt(urlCaseId),
                name: title,
                ext: 'pdf',
                mainInfo: processedContent,
                additionalInfo: extraDescription,
                sharedTemp: isShared,
                shared: isSharedExpert,
                blank: isBlank,
                documentType: documentType,
                isExtentionAttachment: isExtentionAttachment,
                internal: CaseFilesInternal.No,
                status: CaseFilesStatus.ReadyForVisage,
                decline: declineStatus,
                approvalDocument: approvalDocument,
                oldDocumentId: oldDocId,
                tempProlongationDays: tempProlongationDays,
                conditionalDeadLine: conditionalDeadLine,
                termOfPermitDate: termOfPermitDate,
                declinedInternalStatus: 0,
                postpone: postpone,
                answerStatus: answerStatus,
                toUserId: toUserId,
                departamentId: departmentID,
                activeUserId: activeUserId,
                isDocumentInternal: isDocumentInternal,
                pureDays: pureDays,
                postponeDate: postponeDate,
                additionalInternalDocumentation: additionalInternalDocumentation,
                casefileNumber: newFileNumber,
                orderDecision: orderDecision,
                html: processedContent,
                isHTML: true,
                skipVisage: skipVisage,
                isSecretDoc: declineStatus !== CaseFileDeclined.secretDocument ? null : hideCase ? 1 : 3,

            };

            try {
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBody);


                const childrenFiles = caseFiles.filter(file => file.parentId === oldDocId)
                if (childrenFiles.length !== 0) {
                    for (const file of childrenFiles) {
                        await editAttachmentFiles(file, response.data.resultId);
                    }
                }
                await sendNotification(response.data.resultId)
                onFileAdded();

            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
                setIsEditing(false)
                setShowPopup(false);
            }
    };


    useEffect(() => {
        if (showPopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showPopup]);

    return (
        <div><Tooltip title={"დოკუმენტის რედაქტირება"}>
            <div>
                <FaEdit className={"send-for-visage-doc-button"} onClick={() => {
                    setShowPopup(true);
                }}>
                </FaEdit>
            </div>
        </Tooltip>
            {showUploadPopupAttachment && caseData && fileIdForAttachment && caseData && (
                <UploadSingleAttachment
                    onClose={toggleUploadPopupAttachment}
                    onFileUpload={fetchCaseFiles}
                    permitTypeId={permitTypeId}
                    fileId={oldDocId}
                    caseData={caseData}
                />
            )}
            {showPopup && (
                <div className="overlay" onClick={(e) => {
                    if (e.target.classList.contains('overlay')) {
                        setCloseModalOn(true);
                    }
                }}>
                    <div className={`custom-scrollbar popup-editor ${closing ? 'popup-closing' : ''}`}
                         onClick={(e) => e.stopPropagation()}>
                        {loading || isEditing || isLoadingCaseFiles ? (
                            <div className="loader">
                            </div>
                        ) : (
                            <div className="editor-and-preview-container">
                                <div>
                                    <form onSubmit={handleSubmit}>
                                    <input
                                            type="text"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            placeholder="სათაური"
                                            className={"add-doc-input"}
                                        />


                                        {conditionalDeadLine && (
                                            <div style={{marginBottom: 10}}>
                                                <label style={{marginRight: 10}}>პირობის ვარდა:</label>
                                                <DatePicker
                                                    selected={conditionalDeadLine || null}
                                                    onChange={(date) => setConditionalDeadLine(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    minDate={new Date()}
                                                    locale={ka}
                                                    showYearDropdown
                                                    scrollableYearDropdown
                                                    showMonthDropdown
                                                    placeholderText="აირჩიეთ თარიღი"
                                                />
                                            </div>
                                        )}
                                        {termOfPermitDate && (
                                            <div style={{marginBottom: 10}}>
                                                <label style={{marginRight: 10}}>ნებართვის ვადა:</label>
                                                <DatePicker
                                                    selected={termOfPermitDate || null}
                                                    onChange={(date) => setTermOfPermitDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    minDate={new Date()}
                                                    locale={ka}
                                                    showYearDropdown
                                                    scrollableYearDropdown
                                                    showMonthDropdown
                                                    placeholderText="აირჩიეთ თარიღი"
                                                />
                                            </div>
                                        )}

                                        {
                                            (postpone === 0 || postpone === 1) && (
                                                <div style={{marginBottom: 10}}>
                                                    <label>აირჩიეთ თარიღი</label>
                                                    <DatePicker
                                                        selected={postponeDate}
                                                        onChange={date => setPostponeDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        minDate={minDate}
                                                        maxDate={maxDate}
                                                        excludeDates={excludedDates}
                                                        locale={ka}
                                                        showYearDropdown
                                                        scrollableYearDropdown
                                                        showMonthDropdown
                                                        placeholderText="აირჩიეთ თარიღი"
                                                    />
                                                </div>
                                            )
                                        }
                                        {tempProlongationDays > 0 && (
                                            <input
                                                type="number"
                                                value={tempProlongationDays}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value >= 0) {
                                                        setTempProlongationDays(value);
                                                    }
                                                }}
                                                min="1"
                                                placeholder="დახარვეზების დღეები"
                                                className={"add-doc-input"}
                                            />
                                        )}

                                        <div className="q-editor-container">

                                            <FormControl fullWidth style={{marginBottom: 8}}>
                                                <InputLabel id="font-family-label">შრიფტი</InputLabel>
                                                <Select
                                                    labelId="font-family-label"
                                                    value={fontFamily}
                                                    label="შრიფტი"
                                                    onChange={handleFontChange}
                                                    sx={{backgroundColor: 'white', borderRadius: 1}}
                                                >
                                                    <MenuItem value="DejaVu">DejaVu Sans</MenuItem>
                                                    <MenuItem value="Sylfaen">Sylfaen</MenuItem>

                                                </Select>
                                            </FormControl>
                                            <JoditEditor
                                                key={fontFamily}
                                                value={editorContent}
                                                config={editorConfig}
                                                tabIndex={1}
                                                onBlur={editorContent => setEditorContent(editorContent)}
                                            />

                                        </div>
                                        <textarea
                                            value={extraDescription}
                                            onChange={(e) => setExtraDescription(e.target.value)}
                                            placeholder="დამატებითი აღწერა"
                                            style={{
                                                width: "99.39%",
                                                height: "200px",
                                                resize: "vertical",
                                                margin: "10px 0",
                                            }}
                                        />
                                        {isSecretDoc !== null && (
                                            <FormControlLabel
                                                control={<Checkbox checked={hideCase} onChange={(e) => setHideCase(e.target.checked)}/>}
                                                label="განაცხადის დამალვა"
                                            />
                                        )}

                                        {
                                            declineStatus ?
                                            (declineStatus === CaseFileDeclined.CaseCancellationDocument ||
                                                declineStatus === CaseFileDeclined.CaseCancellationDocumentDeclined) && (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={declineStatus === CaseFileDeclined.CaseCancellationDocument}
                                                            onChange={handleDeclineReasonChange}
                                                            name="declineReason"
                                                            color="primary"
                                                        />
                                                    }
                                                    label="ძალადაკარგულად გამოცხადება"
                                                />
                                            ) : (
                                                <></>
                                            )
                                        }
                                        {
                                            declineStatus ?
                                            (declineStatus === CaseFileDeclined.RequireCaseCancellationBuildingAnswerDenied ||
                                                declineStatus === CaseFileDeclined.RequireCaseCancellationBuildingAnswer) && (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={declineStatus === CaseFileDeclined.RequireCaseCancellationBuildingAnswer}
                                                            onChange={handleDeclineReasonChangeBuilding}
                                                            name="declineReason"
                                                            color="primary"
                                                        />
                                                    }
                                                    label="განუხილველად დატოვება"
                                                />
                                            ) : (
                                                <></>
                                            )
                                        }

                                        <Tooltip title={isSubmitDisabled ? "შეავსეთ ყველა ველი" : ""}>
                                            <button
                                                type="submit"
                                                style={{
                                                    backgroundColor: isSubmitDisabled ? '#ccc' : '#2E76E4',
                                                    color: isSubmitDisabled ? '#666' : 'white',
                                                    cursor: isSubmitDisabled ? 'not-allowed' : 'pointer'
                                                }}
                                                className="doc-submit-button"
                                                disabled={isSubmitDisabled  || loading}
                                            >
                                                დოკუმენტის რედაქტირება
                                            </button>
                                        </Tooltip>
                                    </form>
                                </div>
                                <div className="pdf-preview-container" style={{fontFamily: fontFamily}}>

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{marginBottom: 28}}
                                        startIcon={<AiOutlineCheckCircle />}
                                    >
                                        ცვლილების ნახვა
                                    </Button>
                                    <div className="pdf-page">
                                        <div dangerouslySetInnerHTML={{__html: previewContent}}/>
                                        <div style={{marginTop: previewContent !== "" ? "70px" : "10px"}}
                                             dangerouslySetInnerHTML={{__html: editorContent}}/>
                                    </div>
                                    <Button
                                        style={{marginTop: 8}}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => toggleUploadPopupAttachment(oldDocId)}
                                        endIcon={<MdFileUpload />}
                                        sx={{ mb: 2 }}
                                    >
                                        დანართის ატვირთვა
                                    </Button>
                                    <AllowedFormatsInfo/>
                                    {childrenFiles.length > 0 && (
                                        <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>დოკუმენტის შემქნელი</TableCell>
                                                        <TableCell>დოკუმენტის სახელი</TableCell>
                                                        <TableCell>შეიქმნა</TableCell>
                                                        <TableCell>ქმედება</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {childrenFiles.map((file) => (
                                                        <TableRow key={file.id}>
                                                            <TableCell>{file.fullname}</TableCell>
                                                            <TableCell>
                                                                <a href={file.path} target="_blank"
                                                                   rel="noopener noreferrer">
                                                                    {file.name}
                                                                </a>
                                                            </TableCell>
                                                            <TableCell>{new Date(file.createdAt).toLocaleDateString()}</TableCell>
                                                            <TableCell>
                                                                <Button
                                                                    variant="contained"
                                                                    color="error"
                                                                    style={{
                                                                        height: "40px",
                                                                        width: "120px",
                                                                        marginLeft: "10px"
                                                                    }}
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        setFileToDelete(file);
                                                                        setIsDeleteConfirmModalOpen(true);
                                                                    }}
                                                                >
                                                                    წაშლა
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}


                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    )}
                                </div>
                            </div>
                        )}
                        <IoIosCloseCircle className="upload-single-close-icon-text-editor"
                                          onClick={() => setCloseModalOn(true)}
                        />
                        <ConfirmationModal
                            isOpen={isConfirmModalOpen}
                            onRequestClose={() => setIsConfirmModalOpen(false)}
                            onConfirm={handleConfirmSubmit}
                        />
                        <ConfirmationModal
                            isOpen={isDeleteConfirmModalOpen}
                            onRequestClose={() => setIsDeleteConfirmModalOpen(false)}
                            onConfirm={() => {
                                if (fileToDelete) {
                                    void deleteAttachedDocument(fileToDelete.id);
                                    setIsDeleteConfirmModalOpen(false);
                                    setFileToDelete(null);
                                }
                            }}
                        />
                        <ConfirmationModal
                            isOpen={closeModalOn}
                            onRequestClose={() => setCloseModalOn(false)}
                            onConfirm={handleClosePopup}
                            modalText={"დახურვის შემთხვევაში წაიშლება პროგრესიც!"}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default EditCaseDocument;
